/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ComplianceApprovalRequest = {
  properties: {
    userId: {
      type: 'string',
      isRequired: true,
    },
    professionalId: {
      type: 'string',
      isRequired: true,
    },
    reason: {
      type: 'string',
      isRequired: true,
    },
    document: {
      type: 'File',
    },
    complianceRecommendation: {
      type: 'ComplianceRecommendation',
    },
  },
} as const;
